import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/global/Header";
import Sign from "./signItem"
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect,useMemo } from 'react';
import { getSigns } from "../../slices/sign";



const Signs = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);

  const signs = useSelector((state) => state.sign.data.list);

  useEffect(() => {

    dispatch(getSigns({page,pageSize}));

  }, [page,pageSize]);

  return (
    <Box m="20px">

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Signs" subtitle="Welcome to your signs" />
      </Box>

      {/* GRID */}
      <Box
      justifyContent="flex-start"
        margin="0 auto"
        display="grid"
        gridTemplateColumns="repeat(auto-fill, 500px)"

        rowGap="20px"
        columnGap="20px"
      >
      
      {signs &&
        signs.map((sign) => (
            <Sign sign={sign} key={sign.id} />
          ))
      }


      </Box>
    </Box>
  );
};

export default Signs;
